import { TlsAccount } from '@common/schemas/tlsAccount';
import { QueryKeys, useCustomQuery } from '@queries/index';
import Config from '../../config';


type UseTlsAccountsParams = {
  periodName: string,
}
export const useTlsAccounts = ({ periodName }: UseTlsAccountsParams) =>
  useCustomQuery<TlsAccount[]>(
    [QueryKeys.tlsAccounts.TlsAccountsList, periodName],
    {
      url: Config.endpoints.FETCH_TLS_ACCOUNTS.replace(/:periodName/, periodName),
      errorMessage: 'Fetching TLS Accounts failed',
      defaultData: [],
      enabled: !!periodName,
    }
  );
